import { makeStyles } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PlateSamplingHeader from '../../QualityCheck/Creation/PlateSamplingHeader';
import PlateSamplingLeftBar from '../../QualityCheck/Creation/PlateSamplingLeftBar';
import QualityCheckForm from '../../QualityCheck/Creation/QualityCheckForm';
import SamplingResultsOKContent from '../../QualityCheck/Result/SamplingResultsOKContent';
import SamplingResultsNotOKContent from '../../QualityCheck/Result/SamplingResultsNotOKContent';
import { useHistory } from 'react-router-dom';
import { dataService } from '../../../Services/data.service'
import { toast } from 'react-toastify';
import AlertDialog from '../../Shared/Dialogs/AlertDialog';

export default function PlateSamplingPage(props) {
    const classes = useStyles();
    const { t } = useTranslation();
    let history = useHistory();
    const [productionOrder, setProductionOrder] = useState(null)
    const [resultShown, setResultShown] = useState(false)
    const [qualityChecksNotOk, setQualityChecksNotOk] = useState([])
    const [qualityChecks, setQualityChecks] = useState(null)
    const [wrongBarcodeDialogOpen, setWrongBarcodeDialogOpen] = useState(false)
    const [dialogTitle, setDialogTitle] = useState(null)
    const [dialogContext, setDialogContext] = useState(null)

    useEffect(() => {

        dataService.getOrderDetailsByOrderId(parseInt(props.match.params.id)).then(order => {
            if (JSON.stringify(productionOrder) !== JSON.stringify(order)) {
                setProductionOrder(order)
            }

            dataService.getQualitySamplesByBarcode(props.match.params.barcode, props.match.params.id, order.bomOut[0].productId).then(qualitySamples => {
                if (!qualitySamples) {
                    setDialogTitle(t("Wrong barcode!"))
                    setDialogContext(t("Given barcode ") + props.match.params.barcode + t(" is not assigned to production order ") + order.reference)
                    setWrongBarcodeDialogOpen(true)
                }

                if (JSON.stringify(qualityChecks) !== JSON.stringify(qualitySamples)) {
                    setQualityChecks(qualitySamples)
                    if (props.match.params.samplesTaken === '1') {
                        setResultShown(true)
                        var sequence = qualitySamples.qualitySamples.length - 2
                        var i;
                        var qualitySamplesNotOK = []
                        for (i = 0; i < qualitySamples.qualitySamples[sequence].samples.length; i++) {
                            if (!qualitySamples.qualitySamples[sequence].samples[i].resultOk) {
                                qualitySamplesNotOK.push(qualitySamples.qualitySamples[sequence].samples[i])
                            }
                        }

                        setQualityChecksNotOk(qualitySamplesNotOK)
                    }
                }
            }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })

        }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })

    }, [props.match.params.id])


    const finishTest = () => {
        history.push('/qualitychecks/' + props.match.params.progress + "/" + props.match.params.id)
    }

    const wrongBarcodeAction = () => {
        history.push('/order/' + props.match.params.id)
    }

   

    return (
        <div className={classes.background}>
            {productionOrder && qualityChecks ? <React.Fragment><PlateSamplingHeader productionOrder={productionOrder} {...props}></PlateSamplingHeader>
                <div className={classes.body}>
                    <PlateSamplingLeftBar productionOrder={productionOrder} barcode={props.match.params.barcode} {...props}></PlateSamplingLeftBar>
                    {resultShown ? qualityChecksNotOk.length === 0 ? <SamplingResultsOKContent finishTest={finishTest}></SamplingResultsOKContent> : <SamplingResultsNotOKContent finishTest={finishTest} qualityChecksNotOK={qualityChecksNotOk} productionOrder={productionOrder} {...props}></SamplingResultsNotOKContent> : <QualityCheckForm setQualityChecks={setQualityChecks} productionOrder={productionOrder} qualityChecks={qualityChecks} {...props} progress={props.match.params.progress} palletNumber={props.match.params.barcode}></QualityCheckForm>}
                </div></React.Fragment> : <React.Fragment></React.Fragment>}
            <AlertDialog dialogOpen={wrongBarcodeDialogOpen} dialogTitle={dialogTitle} dialogContext={dialogContext} closeDialog={() => setWrongBarcodeDialogOpen(false)} action={() => wrongBarcodeAction()}></AlertDialog>
        </div>
    )
}

const useStyles = makeStyles({
    background: {
        paddingTop: "40px",
        paddingLeft: "30px"
    }
});